import {gsap} from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';


export default function animations() {
    gsap.registerPlugin(ScrollTrigger);
    const window_width = window.innerWidth;

    if (window_width >= 704) {
        // Home - Hero Starting Animation
        if ($('body').hasClass('home')) {
            const tlHomeHero = gsap.timeline();
            gsap.set('.hero-recto__text > *', {opacity: 0, scale: 0.8, x: 20});
            gsap.set('.hero-title', {opacity: 0});
            gsap.set('.hero-image', {opacity: 0, x: 200});
            tlHomeHero.to('.hero-recto__text *', {
                duration: 0.4,
                stagger: 0.12,
                ease: 'power2.out',
                opacity: 1,
                scale: 1,
                x: 0,
                delay: 0.35,
            });
            tlHomeHero.to('.hero-title', {duration: 1, ease: 'power2.out', opacity: 1}, 0.65);
            tlHomeHero.to('.hero-image', {duration: 0.6, ease: 'power3.out', opacity: 1, x: 0}, 1.25);
        }

        // Community - Signataires de la charte
        if ($('body').hasClass('template-community')) {
            gsap.set('.signatory-item', {opacity: 0, scale: 0.75});
            ScrollTrigger.create({
                trigger: '.trig-anim-signatory',
                start: 'bottom+=50 bottom',
                onEnter: () => {
                    gsap.to('.signatory-item', {
                        duration: 0.5, stagger: 0.15, ease: 'power4.out', scale: 1, opacity: 1, delay: 0.1,
                    });
                },
            });

            // Community - Les labels
            gsap.set('.label-item', {opacity: 0, scale: 0.75});
            ScrollTrigger.create({
                trigger: '.label-item__listing',
                start: 'bottom bottom',
                onEnter: () => {
                    gsap.to('.label-item', {
                        duration: 0.5, stagger: 0.15, ease: 'power4.out', scale: 1, opacity: 1, delay: 0.1,
                    });
                },
            });
        }

        // Mesures - Mesures delayed appearance
        if ($('body').hasClass('template-measures')) {
            gsap.set('.measure-item', {opacity: 0, scale: 0.85});
            $('.measure-item').each(function () {
                ScrollTrigger.create({
                    trigger: $(this),
                    start: '50% bottom',
                    onEnter: () => {
                        const delay_increment = $(this).parent().index() % 3;
                        gsap.to($(this), {
                            opacity: 1, duration: 0.35, ease: 'power2.out', scale: 1, delay: 0.15 * delay_increment,
                        });
                        $(this).addClass('animated');
                    },
                });
            })
        }
    }
}



// WEBPACK FOOTER //
// ./scripts/modules/animations.js